import {IDiseaseFakeModelElementCollection} from "@/entities/diseaseParameters/IDiseaseFakeModelElementCollection";

export class DiseaseParametersModel {
    cancerType: string;
    cancerStage: string;
    molecularAlteration: string;
    alterationType: string | null;
    pdL1Status: string | null;

    constructor(cancerType: string = 'lungCancer', cancerStage: string = 'fourthStage', molecularAlteration: string = 'presence', alterationType: string = 'alk', pdL1Status: string = 'less50') {
        this.cancerType = cancerType;
        this.cancerStage = cancerStage;
        this.molecularAlteration = molecularAlteration;
        this.alterationType = alterationType;
        this.pdL1Status = pdL1Status;
    }

    isAlterationsPresents(): boolean {
        return this.molecularAlteration === 'presence';
    }

    toRequestViewModel() {
        const model: any = {
            cancerType: this.cancerType,
            cancerStage: this.cancerStage,
            molecularAlteration: this.molecularAlteration,
        };

        if (this.molecularAlteration === 'presence') {
            model.alterationType = this.alterationType;
        } else {
            model.pdL1Status = this.pdL1Status;
        }

        return model;
    }

    static createFakeData(): IDiseaseFakeModelElementCollection {
        const result: IDiseaseFakeModelElementCollection = {
            typesOfCancer: [{
                id: 'lungCancer',
                name: 'Lung Cancer',
                enabled: true,
            }, {
                id: 'breastCancer',
                name: 'Breast Cancer',
                enabled: false,
            }, {
                id: 'colorectalCancer',
                name: 'Colorectal Cancer',
                enabled: false,
            }, {
                id: 'prostateCancer',
                name: 'Prostate Cancer',
                enabled: false,
            }],
            stagesOfCancer: [{
                id: 'firstStage',
                name: 'I',
                enabled: false,
            }, {
                id: 'secondStage',
                name: 'II',
                enabled: false,
            }, {
                id: 'thirdStage',
                name: 'III',
                enabled: false,
            }, {
                id: 'fourthStage',
                name: 'IV',
                enabled: true,
            }],
            alterations: [{
                id: 'presence',
                name: 'Presence',
                enabled: true,
            }, {
                id: 'absence',
                name: 'Absence',
                enabled: true,
            }],
            typesOfAlteration: [{
                id: 'egfr',
                name: 'EGFR+',
                enabled: true,
            }, {
                id: 'alk',
                name: 'ALK+',
                enabled: true,
            }, {
                id: 'roS1',
                name: 'ROS1+',
                enabled: true,
            }, {
                id: 'brafV600E',
                name: 'BRAF V600E+',
                enabled: true,
            }, {
                id: 'ret',
                name: 'RET+',
                enabled: true,
            }, {
                id: 'met',
                name: 'MET+',
                enabled: true,
            }, {
                id: 'ntrk',
                name: 'NTRK+',
                enabled: true,
            }],
            pdl1Statuses: [{
                id: 'less50',
                name: 'PD-L1 ≥ 50%',
                enabled: true,
            }, {
                id: 'independent',
                name: 'PD-L1 Independent',
                enabled: true,
            }, {
                id: 'citIneligible',
                name: 'CIT ineligible',
                enabled: true,
            }],
        };

        return result;
    }
}
